import React from 'react';
import PropTypes from 'prop-types';

const { default: Popup } = require('../../Popup');

const PreventProAmDivisionCategoryPopup = ({ setShowPopup }) => {
    return (
        <Popup
            className="popup-sm"

            onCloseClick={() => {
                setShowPopup(false);
            }}
            config={{
                fullScreen: false,
                scrollable: false,
                style: { maxHeight: '300px' },
                noPadding: true,
                gradient: true,

            }}
        >
            <div className="popup-section p24 pt0 pb0">
                <h5 className="text-dark mb0">
                    Warning!
                </h5>
            </div>
            <div className={` `}>
                <p className="text-medium pt12 p24 ">
                    Your update(s) create registration conflicts for existing registered player(s) and they will remain registered.
                </p>
                <div className={`col-md-12 mb24 d-flex justify-content`}>
                    <button
                        type="button"
                        className="btn btn-primary btn-xl text-uppercase btn-block "

                        onClick={() => {
                            setShowPopup(false);
                        }}
                    >
                        Got it
                    </button>
                </div>
            </div>
        </Popup>
    );
};
PreventProAmDivisionCategoryPopup.propTypes = {
    setShowPopup: PropTypes.func,
};

PreventProAmDivisionCategoryPopup.defaultProps = {
    setShowPopup: () => { },
};

export default PreventProAmDivisionCategoryPopup;
